export default __webpack_public_path__ + "static/thumb-6-df95ab3e18c7a536af1464d0ccc21b47.jpg";